import { ConciliationReportViewType, VIEW_TYPES } from "../../../types";

interface ReportTabsProps {
  activeTab: ConciliationReportViewType;
  onTabChange: (tab: ConciliationReportViewType) => void;
}

export default function ReportTabs({ activeTab, onTabChange }: ReportTabsProps) {
  return (
    <div className="flex border-b border-gray-200 mb-4 w-full overflow-x-auto hide-scrollbar whitespace-nowrap">
      {VIEW_TYPES.map((item) => (
        <button
          key={item.value}
          type="button"
          className={`px-4 py-2 text-sm font-medium focus:outline-none transition-colors relative ${
            activeTab === item.value
              ? "text-[#2E0D1E]"
              : "text-gray-400 hover:text-[#2E0D1E]"
          }`}
          onClick={() => onTabChange(item.value)}
        >
          {item.label}
          {activeTab === item.value && (
            <span
              className="absolute left-1/2 -translate-x-1/2 bottom-0 w-3/4 h-[2px] bg-[#2E0D1E] rounded-t"
              style={{ content: "" }}
            />
          )}
        </button>
      ))}
    </div>
  );
}
